import { IPlanViewModel, IUserPlanViewModel } from 'viewModels';
import { IPlanInputModel, IPlanUpdateInputModel } from 'inputModels';
import api from '../services/api/axios';

const create = (data: IPlanInputModel) =>
  new Promise<string>((resolve, reject) => {
    api
      .post('plan', data)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const getById = (id: string) =>
  new Promise<IPlanViewModel>((resolve, reject) => {
    api
      .get(`plan/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const getAll = () =>
  new Promise<IPlanViewModel[]>((resolve, reject) => {
    api
      .get('plan')
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const getActive = () =>
  new Promise<IPlanViewModel[]>((resolve, reject) => {
    api
      .get('plan/active')
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const update = (data: IPlanUpdateInputModel) =>
  new Promise<IPlanViewModel>((resolve, reject) => {
    api
      .put('plan', data)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const deletePlan = (id: string) =>
  new Promise<void>((resolve, reject) => {
    api
      .delete(`plan/${id}`)
      .then(() => resolve())
      .catch(reject);
  });

const disable = (id: string) =>
  new Promise<void>((resolve, reject) => {
    api
      .put(`plan/${id}/disable`)
      .then(() => resolve())
      .catch(reject);
  });

const enable = (id: string) =>
  new Promise<void>((resolve, reject) => {
    api
      .put(`plan/${id}/enable`)
      .then(() => resolve())
      .catch(reject);
  });

const startCheckout = (planId: string) =>
  new Promise<string>((resolve, reject) => {
    api
      .post(`payment/create-checkout-session/${planId}`)
      .then(({ data }) => resolve(data?.url))
      .catch(reject);
  });

const getUserPlan = () =>
  new Promise<IUserPlanViewModel>((resolve, reject) => {
    api
      .get('payment/user-plan')
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const removeUserFromPlan = (userId: string, planId: string) =>
  new Promise<void>((resolve, reject) => {
    api
      .delete(`plan/${planId}/user/${userId}`)
      .then(() => resolve())
      .catch(reject);
  });

export const PlanController = {
  create,
  getById,
  getAll,
  getActive,
  update,
  delete: deletePlan,
  disable,
  enable,
  startCheckout,
  getUserPlan,
  removeUserFromPlan,
};
